import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../../config";

const apiUrl = config.apiUrl;

const CreateJoiningInstruction = ({ onJoiningInstructionCreated }) => {
  const [formData, setFormData] = useState({
    slug: "",
    icon: "",
    title: "",
    subtitle: "",
    items: [{ icon: "", description: "" }]
  });

  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleItemChange = (index, e) => {
    const { name, value } = e.target;
    const updatedItems = [...formData.items];
    updatedItems[index] = { ...updatedItems[index], [name]: value };
    setFormData(prev => ({ ...prev, items: updatedItems }));
  };

  const addItem = () => {
    setFormData(prev => ({
      ...prev,
      items: [...prev.items, { icon: "", description: "" }]
    }));
  };

  const removeItem = (index) => {
    const updatedItems = formData.items.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, items: updatedItems }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await axios.post(`${apiUrl}/joininginstructions`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (onJoiningInstructionCreated) {
        onJoiningInstructionCreated();
      }
      
      // Reset form after successful submission
      setFormData({
        slug: "",
        icon: "",
        title: "",
        subtitle: "",
        items: [{ icon: "", description: "" }]
      });
      
      alert("Joining Instruction created successfully!");
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "An error occurred while creating the Joining Instruction.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Joining Instruction</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Slug (URL identifier):</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., how-to-join"
          />
        </div>

        <div>
          <label className="block mb-1">Icon (class or URL):</label>
          <input
            type="text"
            name="icon"
            value={formData.icon}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="e.g., fas fa-user-plus or image URL"
          />
        </div>

        <div>
          <label className="block mb-1">Title:</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., How to Join"
          />
        </div>

        <div>
          <label className="block mb-1">Subtitle:</label>
          <input
            type="text"
            name="subtitle"
            value={formData.subtitle}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="e.g., Follow these steps to become a member"
          />
        </div>

        <div className="border-t pt-4">
          <div className="flex justify-between items-center mb-2">
            <h3 className="font-medium">Instruction Items</h3>
            <button
              type="button"
              onClick={addItem}
              className="text-sm bg-blue-500 text-white px-2 py-1 rounded"
            >
              Add Item
            </button>
          </div>

          {formData.items.map((item, index) => (
            <div key={index} className="mb-4 p-3 border rounded">
              <div className="flex justify-between mb-2">
                <span className="font-medium">Item {index + 1}</span>
                {formData.items.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeItem(index)}
                    className="text-red-500 text-sm"
                  >
                    Remove
                  </button>
                )}
              </div>
              
              <div className="mb-2">
                <label className="block mb-1">Icon:</label>
                <input
                  type="text"
                  name="icon"
                  value={item.icon}
                  onChange={(e) => handleItemChange(index, e)}
                  className="w-full p-2 border rounded"
                  placeholder="e.g., fas fa-check"
                />
              </div>
              
              <div>
                <label className="block mb-1">Description:</label>
                <textarea
                  name="description"
                  value={item.description}
                  onChange={(e) => handleItemChange(index, e)}
                  className="w-full p-2 border rounded"
                  rows="3"
                  required
                  placeholder="Enter step description..."
                ></textarea>
              </div>
            </div>
          ))}
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-2 px-4 bg-green-500 text-white rounded hover:bg-green-600 disabled:bg-gray-400"
        >
          {isSubmitting ? "Creating..." : "Create Joining Instruction"}
        </button>
      </form>
    </div>
  );
};

export default CreateJoiningInstruction;